import { authFetch } from "@/api";
import { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { AlertCircle, CheckCircle, Hourglass } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Link } from "@tanstack/react-router";
import { useMutationComplete } from "@/utils/events";

type HasOverdueResponse = {
  overdueActivitiesCount: number;
}


export const HasOverdue = () => {

  const [data, setData] = useState<HasOverdueResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useMutationComplete((_) => {
      // If the task ID matches, we can refetch the data
      fetchData();
  });

  useEffect(() => {
    fetchData();
  }, [])

  async function fetchData() {
    try {
      setLoading(true);
      let url = `${import.meta.env.VITE_API_URL}/activities/has-overdue`
      const response = await authFetch(url)
      const json = await response.json()
      if (!response.ok) {
        console.error("Errore durante il recupero delle attività:", json)
        setError(json.message || "Errore sconosciuto");
        return;
      }
      setData(json as HasOverdueResponse);
    } catch (error) {
      console.error("Errore durante il recupero delle attività:", error)
      setError(error instanceof Error ? error.message : "Errore sconosciuto");
    } finally {
      setLoading(false);
    }
  }

  if (error) {
    return (
      <></>
    )
  }

  return (
    <div className="mr-2">

      <Popover>
        <PopoverTrigger>
          {
            loading && <Hourglass className="inline-block h-4 w-4 animate-spin" />
          }
          {
            !loading && (data?.overdueActivitiesCount ?? 0) > 0 ?
              <div className="flex items-center gap-2">
                <AlertCircle className="animate-bounce inline-block ml-2 h-4 w-4 text-red-500" />
                {data?.overdueActivitiesCount}
              </div> :
              <CheckCircle className="inline-block ml-2 h-4 w-4 text-green-500" />
          }
        </PopoverTrigger>
        <PopoverContent>
          {
            loading && <p>Loading...</p>
          }
          {
            !loading && (data?.overdueActivitiesCount ?? 0) > 0 ?
              <div className="flex flex-col gap-2 items-center">
                <p>
                  <AlertCircle className="inline-block h-4 w-4 text-red-500" />
                  You have {data?.overdueActivitiesCount} overdue activities
                </p>
                <Button asChild>
                  <Link to="/tasks" search={{ overdue: true }}>View Tasks</Link>
                </Button>
              </div> :
              <div>No overdue activities</div>
          }
        </PopoverContent>
      </Popover>
    </div>
  )

}